module.exports = __webpack_public_path__ + "static/01-a208bf6deba3b99e9d073d910a5bfaaa.jpg";